export const ImportStatusColorMapping = {
  "Not Started": "#B5B5AC",
  "In Progress": "#FFA500",
  Submitted: "#008000",
};

export const NotificationStatusColorMapping = {
  "Not Sent": "#B5B5AC",
  Sent: "#008000",
};

// Keyed by the friendly status description, not the raw status key, so the
// legend reads "Not Started" and "Published Default" rather than "NotStarted"
// and "PublishedDefault". Shared by the Parent Company Status and Individual
// Company Status charts so the same status looks the same on both.
export const ParentCompanyStatusColorMapping = {
  "Not Started": "#B5B5AC",
  "In Progress": "#FFA500",
  "Submitted for Review": "#008000",
  "Publish In Progress": "#77ddaa",
  "Publish Error": "#FF0000",
  Published: "#023020",
  "Published Default": "#356859",
  // Matches STATUS_COLOR_MAP's NotInSeason entry in ParentRenewalDashboard.jsx, so
  // a company not enrolled this season reads the same color on the badge and here.
  "Not In Season": "#6c5ce7",
};
